var OnlineChecker = function (session) {
    this.session = session;
    this.state = true;
};
OnlineChecker.prototype = $.extend({
    checkOnline: function (poll) {
        if (poll) {
            debug.debug('onLine status poll');
        }
        // Change reported, ping server to verify, navigator.onLine can report false negatives
        // https://code.google.com/p/chromium/issues/detail?id=124069
        // Also, wifi can be off but dev VM still available
        this.pingServer().fail(_.bind(function (request, errorString, errorThrown) {
            if (this.onlineStatusSupport() && navigator.onLine) {
                debug.warn('online false positive');
            }
            this.setOnline(false);
        }, this)).done(_.bind(function (response, statusText, request) {
            if (this.onlineStatusSupport() && !navigator.onLine) {
                debug.warn('offline false negative');
            }
            this.setOnline(true);
        }, this));
    },
    setOnline: function (value) {
        if (this.state != value) {
            this.state = value;
            this.trigger('onlineChange');
        }
    },
    pingServer: function () {
        return this.session.ajax({
            url: this.session.backend.buildRawUrl('/ping'),
            type: 'head',
            dataType: 'text'
        });
    },
    isOnline: function () {
        return this.state;
    },
    onlineEventSupport: function () {
        return 'ononline' in window;
    },
    onlineStatusSupport: function () {
        return 'onLine' in navigator;
    },
    onlinePoll: function () {
        if (!this.onlineEventSupport() || !this.isOnline()) {
            this.checkOnline(true);
        }
    },
    start: function () {
        if (this.onlineEventSupport()) {
            $(window).on('online', _.bind(function () {
                debug.log('ononline');
                this.checkOnline();
            }, this));
            $(window).on('offline', _.bind(function () {
                debug.log('onoffline');
                this.checkOnline();
            }, this));
        }
        this.onlinePollInterval = setInterval(_.bind(this.onlinePoll, this), 30000);
    },
}, Backbone.Events);


module.exports = OnlineChecker;



//////////////////
// WEBPACK FOOTER
// ./app/src/onlinechecker.js
// module id = mMVu
// module chunks = 1